import { ById, NormalizedState } from './normalizedState';

export function getItem<T>(state: NormalizedState<T>, id: string): T {
  return state.byId[id];
}

export function getAllWithIds<T>(state: NormalizedState<T>, ids: string[]): T[] {
  return ids ? ids.map(id => state.byId[id]) : undefined;
}

export function getAll<T>(state: NormalizedState<T>): T[] {
  return getAllWithIds(state, state.allIds);
}

export function getAllWithIdsById<T>(state: NormalizedState<T>, ids: string[]): ById<T> {
  return ids ? ids.reduce((acc, id) => ({ ...acc, [id]: state.byId[id] }), {}) : {};
}
